import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import IntellegenceMarketSolutions from "../components/droneParts/IntellegenceMarketSolutions";
import DroneSoftwareDetails from "../components/droneParts/DroneSoftwareDetails";
import { Header, Footer } from "../shared";
// import DroneParts from '../components/droneParts/DroneParts';

const IntellegenceMarketSolutionPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      {/* <DroneSoftwareDetails /> */}
      <IntellegenceMarketSolutions />
      <Footer />
    </div>
  );
};

export default IntellegenceMarketSolutionPage;
